import { BaseReactiveClass } from 'Classes/BaseReactiveClass';

export class ModelAccountSSN extends BaseReactiveClass {
  constructor({ id, ssn }) {
    if (!id || !ssn) throw new Error('ModelAccountSSN required id and ssn');
    super({ id, ssn });
  }

  get full() {
    return this.ssn || '';
  }

  get short() {
    return this.full?.substr(-4) || '';
  }
}
